  
 import React from 'react'
 
 const About = () => {
   return (
     <div>
        <div style={{ position: 'relative', width: '100%', height: '70vh' }}>
          <img
            src="/image/bg12.jpg" alt="Hotel" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          
          {/* Black semi-transparent overlay */}
          <div style={{
            position: 'absolute',
            top: 0, left: 0,
            width: '100%', height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // 0.4 মানে হালকা কালো
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            fontSize: '3rem',
            fontWeight: 'bold'
          }}>
              About Us
          </div>
        </div>
       <div style={{ backgroundColor: '#f8f1fa', paddingBottom:'40px' }} >
         <div className="container">
           <div className="row align-items-center pt-5">
               {/* Image Part */}
             <div className="col-12 col-md-6  pb-5">
               <img 
                 src="/image/g5.jpg"
                 className="img-fluid w-100"
                 style={{ maxHeight: '100%', objectFit: 'cover' }}
                 alt="Hotel"
               />
               
             </div >

             {/* Text Part ============== */}
             <div className="col-12 col-md-6 " style={{ textAlign: 'left', paddingLeft:"100px" }} >
               <h4 style={{ fontSize: '1.1rem'}} >ABOUT INTERIOX</h4>
               <h1 className="display-6 my-4">
                 <strong>We Provide Outdoor Activities to All Visitors.</strong>
              </h1>
              <p>Our operations span the globe, offering exceptional services across various hotel booking</p>
              <p>On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire.</p>

               <div>
                    <ul>
                    <li>Introduce best the Hotel Booking & their services</li> 
                    <li>Booking mission statement or Luxury hotel</li>
                    <li> Highlight featured on Booking project</li>
                    </ul>
                  </div>
                     <button className='bnt btn-secondarybtn btn-secondary mt-3 p-2 px-4'>CONTACT US </button>
               
             </div>          
           </div>
         </div>
 </div>

      <section>
        <div style={{ backgroundColor: '#f8ffa',  }} >
         <div className="container ">
           <div className="row align-items-center pt-5">
               {/* Image Part */}
             <div className="col-12 col-md-6 ">
               <img src="/image/blog1.jpg" className="img-fluid w-100"style={{ maxHeight: '100%', objectFit: 'cover' }} alt="Hotel"/>
             </div >

             {/* Text Part ============== */}
             <div className="col-12 col-md-6 " style={{ textAlign: 'left', backgroundColor:"#f8faf1",}} >
              <div className=' p-4'  style={{ margin:"55px",}}>
                 <h4 style={{ fontSize: '1.1rem'}} >DISCOVER</h4>
                 <h1 className="display-6 my-4">
                 <strong>The Restaurant</strong></h1>
                 <p>A luxury resort is an upscale vacation destination that offers an exceptional level of comfort, amenities, and services, often set in exotic locations</p>
                 <button className='bnt btn-secondarybtn btn-secondary mt-3 p-2 px-4'>CONTACT US </button>
              </div>
             </div> 
           </div>


            <div className="row align-items-center ">
              {/* Text Part-1 ============== */}
             <div className="col-12 col-md-6 " style={{ textAlign: 'left', backgroundColor:"#f8faf1",  }} >
              <div className=' p-4'  style={{ margin:"55px"}}>
                 <h4 style={{ fontSize: '1.1rem'}} >EXPERIENCE</h4>
                 <h1 className="display-6 my-4">
                     <strong>Spa Center</strong></h1>
                 <p>Spa center is a facility dedicated to providing wellness and relaxation services aimed at rejuvenating both the body and mind.</p>
                 <button className='bnt btn-secondarybtn btn-secondary mt-3 p-2 px-4'>CONTACT US </button>
              </div>
             </div> 
               {/* Image Part-1 */}
             <div className="col-12 col-md-6 ">
               <img src="/image/spa.jpg" className="img-fluid w-100"style={{ maxHeight: '100%', objectFit: 'cover' }} alt="Hotel"/>
             </div >
           </div>


            <div className="row align-items-center">
               {/* Image Part-2 */}
             <div className="col-12 col-md-6 ">
               <img src="/image/gym-1.jpg" className="img-fluid w-100"style={{ maxHeight: '100%', objectFit: 'cover' }} alt="Hotel"/>
             </div >

             {/* Text Part-2 ============== */}
             <div className="col-12 col-md-6 " style={{ textAlign: 'left', backgroundColor:"#f8faf1",  }} >
              <div className=' p-4'  style={{ margin:"55px"}}>
                 <h4 style={{ fontSize: '1.1rem'}} >MODERN</h4>
                 <h1 className="display-6 my-4">
                 <strong>Fitness Center</strong></h1>
                 <p>Fitness center is a facility equipped with a variety of exercise machines, weights, and other fitness tools designed to help individuals improve</p>
                 <button className='bnt btn-secondarybtn btn-secondary mt-3 p-2 px-4'>CONTACT US </button>
              </div>
             </div> 
           </div>



         </div>
 </div>
      </section>
     
       
     </div>
   )
 }
 
 export default About